import { eSaasComponents, SaasCreateFormPropContributors } from '@volo/abp.ng.saas';
import { SaasTenantDto } from '@volo/abp.ng.saas/proxy';
import { ePropType, FormProp, FormPropList } from '@abp/ng.theme.shared/extensions';

const confirmAdminPasswordProp = new FormProp<SaasTenantDto>({
  type: ePropType.Password,
  name: 'ConfirmAdminPassword',
  displayName: 'SaasService::ConfirmAdminPassword',
  // validators: () => [Validators.required],
});

export function confirmAdminPasswordPropContributor(propList: FormPropList<SaasTenantDto>) {
  propList.addByIndex(confirmAdminPasswordProp, 4);
}


export const saasCreateFormPropContributors: SaasCreateFormPropContributors = {
  [eSaasComponents.Tenants]: [
    confirmAdminPasswordPropContributor,
  ],
};
